import { syncHandler } from './handlers/sync';
import { timelineHandler } from './handlers/timeline';
import { membershipHandler } from './handlers/membership';
import { roomHandler } from './handlers/room';
import { roomNameHandler } from './handlers/roomName';
import { unreadHandler } from './handlers/unread';
import { receiptHandler } from './handlers/receipt';
import { roomMemberHandler } from './handlers/roomMember';
import { roomTimelineHandler } from './handlers/Room.timeline';

export function initRoomHandlers() {
    // 初始化所有事件处理器
    syncHandler.init();
    timelineHandler.init();
    membershipHandler.init();
    roomHandler.init();
    roomNameHandler.init();
    unreadHandler.init();
    receiptHandler.init();
    roomMemberHandler.init();
    roomTimelineHandler.init();
}
